module.exports = __webpack_public_path__ + "static/media/video_2.e47f929f.png";